import { createFileRoute } from '@tanstack/react-router'
import { BhooklyAIPage } from '@/components/ai/BhooklyAIPage'

export const Route = createFileRoute('/admin/ai')({
  component: () => <BhooklyAIPage />,
})
